import React, { useEffect, useState } from "react";
import Footer from "../../components/Footer/Footer";
import HomeCard from "../../components/HomeCard/HomeCard";
import banner2 from "../../assets/banner_2.svg";
import icon1 from "../../assets/icon1.jpg";
import icon2 from "../../assets/icon2.jpg";
import icon3 from "../../assets/icon3.jpg";
import { Link } from "react-router-dom";
import styles from "./Home.module.css";
import { useSelector } from "react-redux";
// import { getToken } from "../../firebase.js";

const Home = ({ history }) => {
  const { userInfo } = useSelector((state) => state.userLogin);
  const { adminInfo } = useSelector((state) => state.adminLoginReducer);

  useEffect(() => {
    if (!userInfo && !adminInfo) {
      history.push("/login");
    }
  }, [history]);

  const userI = useSelector((state) => state.adminLoginReducer);
  const { loadingAdmin, errorAdmin } = userI;
  // console.log(loadingAdmin, adminInfo, errorAdmin);

  // const [isTokenFound, setTokenFound] = useState(false);
  // getToken(setTokenFound);

  // console.log(isTokenFound);

  return (
    <div className={styles.container}>
      {/* {isTokenFound && <h1> Notification permission enabled 👍🏻 </h1>}
      {!isTokenFound && <h1> Need notification permission ❗️ </h1>} */}

      <div className={styles.bannerContainer}>
        <div className={styles.textContainer}>
          <h2>
            Arrange Pickup <br />
            {"&"} Delivery
          </h2>
          <p>Anything, Anytime, Anywhere...</p>
        </div>
        <img src={banner2} alt="banner" />
      </div>

      <div className={styles.cardsContainer}>
        <Link to="/pickup-location">
          <HomeCard img={icon1} />
        </Link>
        <Link to="/pickup-location">
          <HomeCard img={icon2} />
        </Link>
        <Link to="/pickup-location">
          <HomeCard img={icon3} />
        </Link>
      </div>

      {/* for later */}
      {/* <Ads /> */}

      <Footer />
    </div>
  );
};

export default Home;
